<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row class="mb-3 border-bottom">
      <b-col>
        <h3>Ürün Düzenle</h3>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn class="m-1" type="button" variant="danger" to="/Products" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth >= 380">Ürünler</span>
        </b-btn>

        <b-btn
          href="#"
          @click.prevent="() => { Refresh(); return false; }"
          class="btn btn-info m-1"
          :size="ButtonSize"
        >
          <i class="material-icons mifix">refresh</i>
          <span class="ml-1" v-if="ScreenWidth >= 380">Yenile</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-alert show variant="danger" v-if="Object.keys(Product).length === 0">Hata!</b-alert>

    <template v-if="Object.keys(Product).length > 0">
      <b-alert class="mt-3" show variant="info">Düzenlenen ürün: {{ ProductOldName }}</b-alert>

      <form @submit.prevent="SaveProduct">
        <b-form-group class="formgroup" label="Kategori">
          <b-form-select v-model="Product.CategoryID" :options="CategoriesGUI"></b-form-select>
        </b-form-group>

        <b-form-group class="formgroup" label="Mutfak">
          <b-form-select v-model="Product.KitchenID" :options="KitchensGUI"></b-form-select>
        </b-form-group>

        <b-form-group
          class="formgroup"
          :label="Enums[index]"
          v-for="(property, index) in ProductGUI"
          :key="index"
        >
          <b-form-input
            :type="['MinPortion', 'Price', 'Portions', 'Sort'].indexOf(index) !== -1 ? 'number' : 'text'"
            v-model="Product[index]"
            @keypress.enter.prevent="SaveProduct"
          ></b-form-input>
        </b-form-group>

        <!-- <b-form-group class="formgroup" label="Durum">
        <b-form-select
          v-model="Product.Status"
          :options="[{value:0, text:'Pasif'}, {value:1, text:'Aktif'}]"
        ></b-form-select>
        </b-form-group>-->

        <div class="m-t-40 d-block border-top pt-3 pl-3">
          <b-btn type="submit" variant="success" size="lg">
            <i class="material-icons mifix">save</i>
            <span class="ml-1">Kaydet</span>
          </b-btn>
        </div>
      </form>

      <b-row class="mt-4 pt-4 border-top border-info">
        <b-col cols="12" md="5" class="badge-semilight mb-2 pt-3">
          <b-row>
            <b-col class="mb-3">
              <b-btn
                :to="`/Products/${Product.ID}/OptionTypes/Add`"
                class="btn btn-info"
                :size="ButtonSize"
              >
                <i class="material-icons mifix">add</i>
                <span class="ml-1">Seçenek Türü Ekle</span>
              </b-btn>
            </b-col>
          </b-row>

          <b-table
            striped
            hover
            :sort-by.sync="ExtraTypesSortBy"
            :sort-desc.sync="ExtraTypesSortDesc"
            :items="ExtraTypes"
            :fields="ExtraTypesFields"
            dark
            responsive
            show-empty
          >
            <template v-slot:empty>
              <h6>Seçenek türü tanımlanmamış.</h6>
            </template>

            <template v-slot:cell(Name)="data">
              <div class="ws-nowrap">{{ data.item.Name }}</div>
            </template>

            <template v-slot:cell(Actions)="data">
              <b-btn
                size="sm"
                :to="`/Products/${Product.ID}/OptionTypes/${data.item.ID}`"
                class="btn-info mr-2"
              >
                <i class="material-icons semifix">edit</i>
                <span class="ml-1">Düzenle</span>
              </b-btn>
            </template>
          </b-table>
        </b-col>

        <b-col cols="12" md="7" class="pt-3" v-if="Object.keys(ExtraTypes).length > 0">
          <b-row>
            <b-col class="text-right mb-3">
              <b-btn
                :to="`/Products/${Product.ID}/Options/Add`"
                class="btn btn-info"
                :size="ButtonSize"
              >
                <i class="material-icons mifix">add</i>
                <span class="ml-1">Seçenek Ekle</span>
              </b-btn>
            </b-col>
          </b-row>

          <b-table
            striped
            hover
            :sort-by.sync="ExtrasSortBy"
            :sort-desc.sync="ExtrasSortDesc"
            :items="Extras"
            :fields="ExtrasFields"
            responsive
            show-empty
          >
            <template v-slot:empty>
              <h6>Ürün seçeneği yok.</h6>
            </template>

            <template v-slot:cell(Name)="data">
              <div class="ws-nowrap">{{ data.item.Name }}</div>
            </template>

            <template v-slot:cell(Actions)="data">
              <b-btn
                size="sm"
                :to="`/Products/${Product.ID}/OptionTypes/${data.item.TypeID}/Options/${data.item.ID}`"
                class="btn-info mr-2"
              >
                <i class="material-icons semifix">edit</i>
                <span class="ml-1">Düzenle</span>
              </b-btn>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../Service";

export default {
  data() {
    return {
      Enums: {
        Name: "Ürün Adı",
        Portions: "Artış Miktarı",
        MinPortion: "Min. Porsiyon",
        Price: "Fiyat",
        Sort: "Sıralama"
      },
      ProductOldName: "",
      Product: {},
      ExtraTypesSortBy: "Name",
      ExtraTypesSortDesc: false,
      ExtrasSortBy: "Name",
      ExtrasSortDesc: false,
      ExtraTypesFields: [
        { key: "Name", label: "Seçenek Türü", sortable: true },
        { key: "Actions", label: "İşlem", sortable: false }
      ],
      ExtrasFields: [
        { key: "Name", label: "Seçenek", sortable: true },
        { key: "Price", label: "Fiyat", sortable: true },
        { key: "Actions", label: "İşlem", sortable: false }
      ],
      ProductGUI: {},
      CategoriesGUI: [],
      KitchensGUI: [],
      ExtraTypes: [],
      Extras: []
    };
  },
  async created() {
    await this.Refresh();
  },
  computed: {
    ...mapState(["StoreData", "ScreenWidth", "ButtonSize"]),
    ParamID() {
      return this.$route.params.ID;
    }
  },
  methods: {
    async GetProductGUI() {
      await this.$set(
        this,
        "ProductGUI",
        Object.filterKey(
          this.Product,
          x =>
            [
              "ID",
              "CategoryID",
              "KitchenID",
              "Extras",
              "ExtraTypes",
              "Status"
            ].indexOf(x) === -1
        )
      );
    },
    async GetCategoriesGUI() {
      let _Categories = [];

      for (let i in this.StoreData.Categories) {
        const _Category = this.StoreData.Categories[i];

        _Categories.push({
          value: _Category.ID,
          text: _Category.Name
        });
      }

      await this.$set(this, "CategoriesGUI", _Categories);
    },
    async GetKitchensGUI() {
      let _Kitchens = [];

      for (let i in this.StoreData.Kitchens) {
        const _Kitchen = this.StoreData.Kitchens[i];

        _Kitchens.push({
          value: _Kitchen.ID,
          text: _Kitchen.Name
        });
      }

      await this.$set(this, "KitchensGUI", _Kitchens);
    },
    async GetExtraTypes() {
      let _ExtraTypes = [];

      if (this.Product.ExtraTypes) {
        for (let i in this.Product.ExtraTypes) {
          const _ExtraType = this.Product.ExtraTypes[i];

          _ExtraTypes.push({
            ID: _ExtraType.ID,
            Name: _ExtraType.Name
          });
        }
      }

      await this.$set(this, "ExtraTypes", _ExtraTypes);
    },
    async GetExtras() {
      let _Extras = [];

      if (this.Product.Extras) {
        for (let i in this.Product.Extras) {
          const _Extra = this.Product.Extras[i];

          _Extras.push({
            ID: _Extra.ID,
            TypeID: _Extra.TypeID,
            Name: `${_Extra.TypeName} - ${_Extra.Name}`,
            Price: _Extra.Price ? _Extra.Price.Money() : "Ücretsiz"
          });
        }
      }

      await this.$set(this, "Extras", _Extras);
    },
    async Refresh() {
      if (
        this.StoreData.Products !== undefined &&
        this.StoreData.Products[this.ParamID] !== undefined
      ) {
        let _Product = Object.assign({}, this.StoreData.Products[this.ParamID]);

        await this.$set(this, "ProductOldName", _Product.Name);
        await this.$set(this, "Product", _Product);
      }

      await this.GetProductGUI();
      await this.GetCategoriesGUI();
      await this.GetKitchensGUI();
      await this.GetExtraTypes();
      await this.GetExtras();

      await this.$nextTick();
      await this.$forceUpdate();
    },
    async SaveProduct() {
      await this.$store.dispatch("AddLoading", "SaveProduct");

      await Services.Nozich.Send(
        "SaveProduct",
        {
          ID: this.ParamID,
          Product: this.Product
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "SaveProduct");

          if (Data.Status === "Success") {
            await this.$router.push("/Products");
          }
        }
      );
    }
  },
  async mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
